import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facility } from 'src/app/services/firebase-utilities.service';
import { SharingPatientId } from '../sharing-setup/sharing-setup.component';

@Component({
    selector: 'app-patients-actions-facility',
    templateUrl: './patients-actions-facility.component.html',
    styleUrls: ['./patients-actions-facility.component.scss'],
    standalone: false
})
export class PatientsActionsFacilityComponent {
  @Input() facilities: Facility[] = [];
  @Input() selectedFacility: SharingPatientId | null = null;

  @Output() facilitySelected = new EventEmitter<Facility>();

  facilitySearchQuery = '';

  get filteredFacilities(): Facility[] {
    const query = this.facilitySearchQuery.toLowerCase().trim();
    if (!query) {
      return this.facilities || [];
    }
    return (this.facilities || []).filter(facility => {
      const name = (facility.name || '').toLowerCase();
      const id = (facility.id || '').toLowerCase();
      const address = (facility.address || '').toLowerCase();
      return name.includes(query) || id.includes(query) || address.includes(query);
    });
  }
}
